var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Bar Chart, 柱状图、条形图。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("attrs 包含若干布局属性，将这些属性放入 Object 对象传入组件")
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("barWidth")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("根据 size 宽度均匀绘制")]),
            _vm._v(" "),
            _c("td", [_vm._v("描述柱形宽度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("mouseDisabled")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("组件鼠标是否禁用")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{top,right,bottom,left,width,height}")]),
            _vm._v(" "),
            _c("td", [_vm._v("设置了 width,heigh,优先与 bottom,right")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("splitNumber")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("0")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "坐标轴的分割段数，用来计算柱子的最大高度，在设置坐标轴的 splitNumber 属性时同步加上"
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("stack")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("是否设置为堆叠图，二维数据无法堆叠")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("stackGap")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("0")]),
            _vm._v(" "),
            _c("td", [_vm._v("堆叠图中柱子间距")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("transpose")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("是否设置为条形图")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style 属性")]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基本类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("backgroundpillar")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("背景柱子样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("pillar")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("柱子样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("pillar:hover")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("鼠标 hover 时柱子样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("text")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本样式")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("使用方法可在"),
        _c("a", { attrs: { href: "#/demo/column/others" } }, [
          _vm._v("样式调整 demo")
        ]),
        _vm._v("中查看，用法如下：")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("style 设置方式可以是 Boolean、 obj 属性或者函数，例如：")
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("// 新建Bar组件")
            ]),
            _vm._v("\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" bar = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Bar()\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//设置true或false来隐藏组件元素")
            ]),
            _vm._v("\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//隐藏背景柱")
            ]),
            _vm._v("\nbar.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"backgroundpillar"')
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("false")
            ]),
            _vm._v(")\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//设置spritejs的attr属性来设置样式")
            ]),
            _vm._v("\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//设置鼠标移入柱子时样式")
            ]),
            _vm._v("\nbar.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"pillar:hover"')
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("bgcolor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"#f00"')
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("opacity")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"0.5"')
            ]),
            _vm._v(" })\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//attrs为元素绘制属性，data为元素对应数据，i为元素序列")
            ]),
            _vm._v("\nbar.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"pillar:hover"')
            ]),
            _vm._v(", (attrs, data, i) => {\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//将偶数序列的柱子设置圆角")
            ]),
            _vm._v("\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("if")
            ]),
            _vm._v(" (i % "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("2")
            ]),
            _vm._v(" === "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("0")
            ]),
            _vm._v(") {\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" {\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("borderRadius")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("10")
            ]),
            _vm._v(",\n    }\n  }\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("opacity")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("0.5")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("bgcolor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"blue"')
            ]),
            _vm._v(" }\n})\n")
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }